module.exports = __webpack_public_path__ + "static/img/opn_bg.058701d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/opn_bg.jpg
// module id = ns3Q
// module chunks = 0